import React from 'react';

export const STUDENT_BOMBS_UI = [
  {
    label: 'Rut', key: 'rut', valueType: 'string', showOnTable: true, typeField: 'text',
  },
  {
    label: 'Nombre', key: 'name', valueType: 'string', showOnTable: true, typeField: 'text',
  },
  {
    label: 'Apellido', key: 'lastname', valueType: 'string', showOnTable: true, typeField: 'text',
  },
  {
    label: 'ID Sección', key: 'mipreuId', valueType: 'string', showOnTable: true, typeField: 'text',
  },
  {
    label: 'Habilidad 1',
    key: 'firstBombSkill',
    valueType: 'custom',
    showOnTable: true,
    typeField: 'text',
    functionToApply: (value: number | null, _rowIndex: number, row: any) => {
      if (value === null || value === undefined) return '-';
      return row.firstFromGeneralStats ? <span>{value}<sup>s</sup></span> : `${value}`;
    },
  },
  {
    label: 'Habilidad 2',
    key: 'secondBombSkill',
    valueType: 'custom',
    showOnTable: true,
    typeField: 'text',
    functionToApply: (value: number | null, _rowIndex: number, row: any) => {
      if (value === null || value === undefined) return '-';
      return row.secondFromGeneralStats ? <span>{value}<sup>s</sup></span> : `${value}`;
    },
  },
  {
    label: 'Habilidad 3',
    key: 'thirdBombSkill',
    valueType: 'custom',
    showOnTable: true,
    typeField: 'text',
    functionToApply: (value: number | null, _rowIndex: number, row: any) => {
      if (value === null || value === undefined) return '-';
      return row.thirdFromGeneralStats ? <span>{value}<sup>s</sup></span> : `${value}`;
    },
  },
];

export type StudentBombSkill = {
  mipreuId: number;
  rut: string;
  name: string;
  lastname: string;
  firstBombSkill: number | null;
  secondBombSkill: number | null;
  thirdBombSkill: number | null;
  firstFromGeneralStats: boolean;
  secondFromGeneralStats: boolean;
  thirdFromGeneralStats: boolean;
};
